import { z } from "zod";
import { WineIdentity } from "./wine.js";

/** Whether the edge reaches its R2 storage, and how fresh the druif slice export there is. */
export const HealthStorage = z.object({
  r2: z.enum(["ok", "down", "unconfigured"]),
  slice: z
    .object({ updatedAt: z.iso.datetime(), sizeBytes: z.number().int().nonnegative() })
    .optional(),
});
export type HealthStorage = z.infer<typeof HealthStorage>;

export const HealthResponse = z.object({
  status: z.literal("ok"),
  environment: z.string(),
  version: z.string(),
  /** Optional so a client built before it (or an edge without it) still parses. */
  storage: HealthStorage.optional(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;

/** Raw barcode as scanned; the worker normalises and validates the check digit. */
export const ScanBarcodeRequest = z.object({
  gtin: z.string().regex(/^\s*[0-9]{8,14}\s*$/),
});
export type ScanBarcodeRequest = z.infer<typeof ScanBarcodeRequest>;

export const ScanBarcodeResponse = z.discriminatedUnion("resolved", [
  z.object({ resolved: z.literal(true), gtin: z.string().length(14), wine: WineIdentity }),
  z.object({ resolved: z.literal(false), gtin: z.string().length(14) }),
]);
export type ScanBarcodeResponse = z.infer<typeof ScanBarcodeResponse>;

export const LabelUploadResponse = z.object({
  id: z.string().uuid(),
  bytes: z.number().int().nonnegative(),
  contentType: z.string(),
});
export type LabelUploadResponse = z.infer<typeof LabelUploadResponse>;

export const ApiError = z.object({
  error: z.string(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof ApiError>;

/** Image types the label endpoint accepts; anything else is 415. */
export const LABEL_CONTENT_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic"] as const;
export const LABEL_MAX_BYTES = 8 * 1024 * 1024;
